import { Time } from "../Helper/Time"
import { WeekType, WeekTypesNumberToWeekTypes } from "../Helper/Week"

export interface ChargePattern {
    chrptn_id?: number
    chrcate_id?: number
    chrptn_charge?: number
    start_date?: Date
    end_date?: Date
    start?: Time
    end?: Time
    std_id?: number
    std_name?: string
    str_id?: number
    week_conditions?: WeekType[]
}
export interface ObjectToChargePatternProps {
    chrptn_id?: number | string
    chrcate_id?: number | string
    chrptn_charge?: number | string
    start_date?: Date | string
    end_date?: Date | string
    start?: Time | string
    end?: Time | string
    std_id?: number | string
    std_name?: string
    str_id?: number | string
    week_conditions?: number | string
}
export const ObjectToChargePattern = (obj: ObjectToChargePatternProps): ChargePattern => {
    let wc = typeof obj.week_conditions == 'string' ? parseInt(obj.week_conditions) : obj.week_conditions
    return {
        chrptn_id: typeof obj.chrptn_id == 'string' ? parseInt(obj.chrptn_id) : obj.chrptn_id,
        chrcate_id: typeof obj.chrcate_id == 'string' ? parseInt(obj.chrcate_id) : obj.chrcate_id,
        chrptn_charge: typeof obj.chrptn_charge == 'string' ? parseInt(obj.chrptn_charge) : obj.chrptn_charge,
        start_date: obj.start_date ? new Date(obj.start_date) : undefined,
        end_date: obj.end_date ? new Date(obj.end_date) : undefined,
        start: obj.start ? new Time(obj.start) : undefined,
        end: obj.end ? new Time(obj.end) : undefined,
        std_id: typeof obj.std_id == 'string' ? parseInt(obj.std_id) : obj.std_id,
        std_name: obj.std_name,
        str_id: typeof obj.str_id == 'string' ? parseInt(obj.str_id) : obj.str_id,
        week_conditions: wc ? WeekTypesNumberToWeekTypes(wc) : undefined
    }
}